module.exports = __webpack_public_path__ + "static/media/1POLICY48.64e03888.jpg";